import React, { useState, useEffect } from 'react';
import { icons, textblocks } from 'seal-ui-components';
import { ScoreCardAnalyticValueDiv } from './ScoreCardAnalyticValue.style';
import { useDispatch, useSelector } from 'react-redux';
import { LOG_TYPE, addLog } from '@Service/loggingService';
import { NOTIFICATION_HANDLER, MIX_PANEL } from '@Constants/types';
import { navigateTextInBody } from '@Actions/wordApiActions';

const ScoreCardAnalyticValue = ({
    value,
    highlighted,
    index,
    name,
    navFailed,
    scorecardIndex,
    extractionIndex,
    filteredAnalytics,
    curExtIndex,
    setCurExtIndex,
    setCurExtNumber,
    policyHighlightHandler,
    riskLevel,
    extractionCount,
    ruleId,
    rulePosition
}) => {
    const [navigateIndex, setNavigateIndex] = useState(0);
    const dispatch = useDispatch();
    const { navigating, clearNavigateCountFlag } = useSelector(state => state.search);

    useEffect(
        () => {
            if (navigateIndex > 0) {
                setNavigateIndex(1); // cycle reset to first item
            } else {
                setNavigateIndex(0); // initial load conditions
            }
        },
        [clearNavigateCountFlag]
    );

    useEffect(
        () => {
            if (curExtIndex >= 0) {
                loopOverPoliciesAndHighlight(
                    filteredAnalytics[curExtIndex].value,
                    filteredAnalytics[curExtIndex].attributes[0].value,
                    filteredAnalytics[curExtIndex].endOffset,
                    true
                );
            }
        },
        [curExtIndex]
    );

    function loopOverPoliciesAndHighlight(extValue, extName, extIdx, skip) {
        const extIndex = filteredAnalytics.findIndex(val => val.value === extValue);

        setCurExtIndex(extIndex);
        setCurExtNumber(curExtIndex + 1);

        try {
            if (!navigating) {
                const mixpanel = {
                    riskLevel,
                    extractionCount,
                    extractionText: extValue,
                    ruleId,
                    rulePosition
                };

                dispatch({
                    type: MIX_PANEL.MIXPANEL_DATA_SCORECARD,
                    payload: mixpanel
                });

                dispatch(
                    navigateTextInBody(
                        extValue,
                        { extName, index: `${extName}-${extIdx}` },
                        navigateIndex
                    )
                );
            }

            policyHighlightHandler(extName, `${extName}-${extIdx}`);
            if (!skip) {
                // dont double increment the counter (initlal conditions fix)
                setNavigateIndex(navigateIndex + 1);
            }
        } catch (err) {
            addLog(LOG_TYPE.ERROR, 'ScoreCardComponent.loopOverPoliciesAndHighlight', err);
            dispatch({
                type: NOTIFICATION_HANDLER.ERROR,
                payload: err
            });
        }
    }

    return (
        <ScoreCardAnalyticValueDiv
            onClick={() => loopOverPoliciesAndHighlight(value, name, index, false)}
            highlighted={highlighted}
            data-testid={`scorecard_${scorecardIndex}_extraction_${extractionIndex}`}
        >
            <icons.ChevronLeftSmallIcon />
            <textblocks.Value {...{ className: `${navFailed ? 'error' : ''}` }}>
                {value}
            </textblocks.Value>
        </ScoreCardAnalyticValueDiv>
    );
};

export default React.memo(ScoreCardAnalyticValue);
